import { Zone, ZoneIdentifier } from '@ekkogmbh/apisdk';
import { Chip, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { dataTableHighlight } from 'src/Common/Components/DataTable';

interface Props {
  zone: ZoneIdentifier | Zone;
  highlightText?: string;
}

export default function ZoneChip({ zone, highlightText }: Props): React.JSX.Element {
  const chipContent = useMemo(
    () => (
      <Stack>
        <Typography fontWeight={600} variant={'body1'}>
          {dataTableHighlight(zone.name ?? '', highlightText)}
        </Typography>
        <Typography variant={'body2'}>{'@' + zone.coordinate}</Typography>
      </Stack>
    ),
    [zone, highlightText],
  );

  return (
    <Chip
      variant={'outlined'}
      style={{
        position: 'relative',
        margin: 8,
        height: 48,
        width: 'fit-content',
        overflow: 'hidden',
        flexShrink: 0,
      }}
      label={chipContent}
    />
  );
}
